import React from 'react';
import { Story } from '../../../models/Story';
import { checkImage } from '../../componentUtils';
import { Gradient } from '../../Global/styles';
import {
	FeaturedItemContainer,
	FeaturedItemImg,
	FeaturedItemInner,
	FeaturedItemMeta,
	FeaturedItemTextContainer,
	FeaturedItemTitle,
} from './featuredItemStyles';
import { StoryHelper } from '../../../models/helpers/Helpers';

import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
// import required modules
import { Pagination } from 'swiper';
import { NavLink } from 'react-router-dom';
import BookmarkStoryButton from '../../Global/BookmarkButton/BookmarkStoryButton';

type FeaturedItemProps = {
	stories: Story[];
};
const FeaturedItem: React.FC<FeaturedItemProps> = ({ stories }) => {
	return (
		<FeaturedItemContainer>
			<Swiper
				pagination={{
					dynamicBullets: true,
				}}
				modules={[Pagination]}
				className="mySwiper styled-pagination navigation-top">
				{stories.map((story) => {
					return (
						<SwiperSlide key={story.id}>
							<NavLink to={'/story/' + story.id}>
								<FeaturedItemInner>
									<FeaturedItemImg
										src={checkImage(story.image)}
									/>
									<Gradient />
									<FeaturedItemTextContainer>
										<FeaturedItemTitle>
											{story.title}
										</FeaturedItemTitle>
										<FeaturedItemMeta>
											{StoryHelper.generateMetaString(
												story,
											)}
										</FeaturedItemMeta>
									</FeaturedItemTextContainer>
								</FeaturedItemInner>
							</NavLink>
							<BookmarkStoryButton storyId={story.id} />
						</SwiperSlide>
					);
				})}
			</Swiper>
		</FeaturedItemContainer>
	);
};

export default FeaturedItem;
